import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedinTeal",
  "use": "linkedinTeal-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"linkedinTeal\">\n<path d=\"M28 24.6667C28 26.508 26.508 28 24.6667 28H7.33333C5.49267 28 4 26.508 4 24.6667V7.33333C4 5.492 5.49267 4 7.33333 4H24.6667C26.508 4 28 5.492 28 7.33333V24.6667Z\" fill=\"#26A69A\" />\n<path d=\"M8 12.6667H11.3333V24H8V12.6667ZM9.65667 11.3333H9.638C8.64333 11.3333 8 10.592 8 9.666C8 8.72 8.66333 8 9.676 8C10.69 8 11.3147 8.72 11.3333 9.666C11.3333 10.5913 10.69 11.3333 9.65667 11.3333ZM24 24H20.6667V17.934C20.6667 16.4687 19.85 15.4687 18.5387 15.4687C17.538 15.4687 16.9967 16.1433 16.734 16.7953C16.638 17.0287 16.6667 17.674 16.6667 18V24H13.3333V12.6667H16.6667V14.4107C17.1473 13.6667 17.9 12.6667 19.8253 12.6667C22.2107 12.6667 23.9993 14.1667 23.9993 17.516L24 24Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/linkedinTeal.svg
// module id = 3Hpo
// module chunks = 13